module.exports = __webpack_public_path__ + "static/media/content-1@768.832507ab.png";